module.exports = __webpack_public_path__ + "img/public-login.8fe88537.svg";